export default from './profile-stats';



// WEBPACK FOOTER //
// ./app/components/profile-stats/index.js